import { useState } from "react";

export default function PublishLineupModal({ initialNote, onClose, onConfirm }) {
  const [note, setNote] = useState(initialNote || "");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  async function handleConfirm() {
    setSubmitting(true);
    setError("");
    try {
      await onConfirm(note.trim());
    } catch (e) {
      setError(e?.message || "Failed to publish lineup.");
      setSubmitting(false);
      return;
    }
    setSubmitting(false);
  }

  return (
    <div
      className="modalOverlay"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15, 23, 42, 0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: 16,
      }}
    >
      <div
        className="modalCard"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: 480,
          background: "var(--bg-elevated)",
          color: "var(--text)",
          borderRadius: 8,
          boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.35)",
        }}
      >
        <div className="modalCardContent" style={{ padding: 24 }}>
          <div className="modalHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <h3 className="h2" style={{ margin: 0 }}>Publish Lineup</h3>
            <button
              className="modal-close"
              aria-label="Close"
              onClick={onClose}
              style={{ background: "none", border: "none", fontSize: 28, cursor: "pointer", lineHeight: 1, color: "var(--muted)" }}
            >
              &times;
            </button>
          </div>

          <p className="help" style={{ margin: "0 0 12px 0" }}>
            Optionally add a note. It will show on the athletes' lineup page and post to this team's Slack channel (if configured).
          </p>

          <textarea
            className="input"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Add a note (optional)…"
            rows={3}
            style={{ width: "100%", resize: "vertical", marginBottom: 12 }}
          />

          {error && <p className="help" style={{ color: "red", marginBottom: 12 }}>{error}</p>}

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <button className="btn ghost" onClick={onClose} disabled={submitting}>
              Cancel
            </button>
            <button className="btn" onClick={handleConfirm} disabled={submitting}>
              {submitting ? "Publishing…" : "Publish"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
